import React from 'react';
import { BodyContent2, Question, BodyText, BodyUrl } from './bseStyle';
import Link from '@/presentation/reusables/Link';

const BSEContent = (props: any) => {
  const { marginBodyContent2 } = props;

  return (
    <BodyContent2 margin={marginBodyContent2}>
      <Question>¿Qué requisito necesito?</Question>
      <div className="PLbody">
        <ul>
          <BodyText>
            Afrontar una situación económica difícil y contar con documentos que
            lo sustenten.
          </BodyText>
          <BodyText>No tener sanciones disciplinarias.</BodyText>
          <BodyText>Sobre el ciclo matriculado:</BodyText>
          <ul>
            <li className="COLOR">
              Estar matriculado mínimo 18 horas o 36 horas en CGT (9 horas
              pregrado en periodo verano).
            </li>
            <li className="COLOR">Estar en 2º ciclo en adelante.</li>
          </ul>
          <BodyText>Sobre tu ciclo inmediato anterior:</BodyText>
          <ul>
            {/* <li className="COLOR">Máximo 1 ciclo desaprobado </li>
            <li className="COLOR">Mínimo 1 curso desaprobado </li> */}
            <li className="COLOR">
              Haber estado matriculado en mínimo 18 horas en pregrado o 36 horas
              en CGT.
            </li>

            <li className="COLOR">
              Mínimo 12 de promedio ponderado del ciclo anterior.
            </li>
          </ul>
        </ul>
      </div>
      <BodyUrl>
        <p>
          Revisa el reglamento de becas de pregrado y CGT ingresa aquí:{' '}
          <Link
            linkType="external"
            url="../../../assets/documents/Reglamento_becas.pdf"
            linkName="https://utp.edu.pe."
          />
        </p>
      </BodyUrl>
    </BodyContent2>
  );
};
export default BSEContent;
